const shadows = {
    level1: '0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
    level2: '0px 1px 8px 0px rgba(0, 0, 0, 0.06)',
    level2Right: '2px 0px 8px 0px rgba(0, 0, 0, 0.06)',
    level3: '0px 0px 12px 0px rgba(0, 0, 0, 0.12)',
}

export default shadows
export type Shadows = typeof shadows
